import { SupervisorMentors } from "@/components/users/user-details/supervisor-mentors/supervisor-mentors";
import { useGetUserSupervisorMentors } from "@/lib/api/user";
import { useAbility } from "@/lib/casl/ability-context";
import { hasPrivilegedAccessFromAbility } from "@/lib/casl/privileged-access";
import { Skeleton } from "@somethings-ui/web";

interface SupervisionTabProps {
  userId: string;
}

export function SupervisionTab({ userId }: SupervisionTabProps) {
  const ability = useAbility();
  const hasPrivilegedAccess = hasPrivilegedAccessFromAbility(ability);
  const { data, isPending } = useGetUserSupervisorMentors(userId, true);
  const canAssignSupervisor =
    hasPrivilegedAccess && ability.can("assign", "supervisor");
  const canUnassignSupervisor =
    hasPrivilegedAccess && ability.can("unassign", "supervisor");

  if (isPending) {
    return <Skeleton className="h-40 w-full" />;
  }

  return (
    <SupervisorMentors
      userId={userId}
      isPending={isPending}
      mentors={data?.mentors ?? []}
      canAssignSupervisor={canAssignSupervisor}
      canUnassignSupervisor={canUnassignSupervisor}
    />
  );
}
